export default "/images/vendor/flag-icon-css/flags/4x3/gp.svg?092b6bf958cd4a1f76c928e77991adf0";